export const ChipsArea: React.FC = ({ children }) => {
  return (
    <div className="mt-2 flex items-center space-x-4 overflow-x-auto whitespace-nowrap px-1 py-2">
      {children}
    </div>
  )
}
